import { Directive, inject } from '@angular/core'
import { ElderEnumTranslationService, ElderSelectComponent } from '@elderbyte/ngx-starter'
import { AttachmentSpecType } from './attachment-spec'

@Directive({
  selector: '[appAttachmentSpecTypeSelect]',
})
export class AttachmentSpecTypeSelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/
  private select = inject(ElderSelectComponent)
  private enumTranslationService = inject(ElderEnumTranslationService)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.select.placeholder = 'attachments.specs.type'
    this.select.displayProperty = 'displayValue'

    this.select.dataSource = this.enumTranslationService.enumDataSource(
      AttachmentSpecType,
      'AttachmentSpecType',
      false
    )
  }
}
